// コメント用スライダー
if( $.isMobile ){
    $('.js-comment-slider').bxSlider({
        auto: false,
        infiniteLoop: true,
        prevSelector: '#js-bx_prev',
        nextSelector: '#js-bx_next',
        prevText: '<i class="icon-syg-arrowmini-left5"></i>',
        nextText: '<i class="icon-syg-arrowmini-right5"></i>',
        //                        paer: false
        //                        pagerCustom: '.characters__select'
    });
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/module/slider.js
 ** module id = 12
 ** module chunks = 0
 **/